import React from "react";
import { cn } from "../../utils/classMerger";
import { AllowanceStatus } from "./types";

// The agent's Niche Finder allowance as a percentage (spec §4.5): never money.
export const formatRefillDate = (resetsOn: string): string =>
    new Date(resetsOn).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "America/New_York" });

export const formatRefill = (resetsOn: string | null): string =>
    resetsOn ? `refills ${formatRefillDate(resetsOn)}` : "refills at your next billing date";

interface InteractiveAiUsageBarProps {
    allowance: AllowanceStatus;
    className?: string;
}

const InteractiveAiUsageBar: React.FC<InteractiveAiUsageBarProps> = ({ allowance, className }) => {
    const pct = Math.max(0, Math.min(100, Math.round(allowance.percentUsed)));
    // Approved-palette traffic-light states, as CaptioningUsageBar (tailwind skill).
    const colour = pct >= 100 ? "bg-[#c62828]" : pct >= 80 ? "bg-[#ffbe00]" : "bg-[#43a047]";
    return (
        <div className={className}>
            <p className="text-xs text-gray-600 mb-1">
                AI allowance: {pct}% used · {formatRefill(allowance.resetsOn)}
            </p>
            <div
                role="progressbar"
                aria-label="AI allowance used"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={pct}
                className="w-full h-2 rounded bg-gray-200 overflow-hidden"
            >
                <div data-testid="ai-allowance-fill" className={cn("h-2", colour)} style={{ width: `${pct > 0 ? Math.max(pct, 4) : 0}%` }} />
            </div>
        </div>
    );
};

export default InteractiveAiUsageBar;
